import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.22792 7.19768L7.00003 10.5525C6.83813 10.7963 6.48193 10.8016 6.31284 10.5627L4.93393 8.61465C4.76497 8.37594 4.4091 8.38102 4.24702 8.62445L2.09783 11.8524C1.91346 12.1293 2.11198 12.5 2.44466 12.5H12.5698C12.8995 12.5 13.0986 12.1352 12.9202 11.8579L9.92544 7.20275C9.76282 6.94997 9.3942 6.94729 9.22792 7.19768Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.75 0C0.375 0 0 0.375 0 0.75V14.25C0 14.625 0.375 15 0.75 15H14.25C14.625 15 15 14.625 15 14.25V0.75C15 0.375 14.625 0 14.25 0H0.75ZM1.04651 1.15385L13.9535 1.15385V13.8462H1.04651V1.15385Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }